import { BaseModal, ModalResultType } from "../../core/modal";
import { ValtasiirtoBaseApp } from "../../app/valtaSiirtoBaseApp";
import { Template } from "../../core/template";
import { ViewEvent } from "../../core/view";
import { ClientAction } from "../../app/synchronizer";
import { OrderFlipcardViewData } from "../../views/orderFlipcard";


export default class AddOrderImageModal extends BaseModal
{
    public template = Template.lazy('/modals/addOrderImage/index.html');
    public app: ValtasiirtoBaseApp;

    public data: AddOrderImageModalViewData;

    private imageFilenameField: HTMLInputElement;
    private imageField: HTMLInputElement;
    private clearImageButton: HTMLButtonElement;
    private cancelButton: HTMLButtonElement;
    private saveButton: HTMLButtonElement;
    private uploadSpeedNotification: HTMLElement;
    private cameraButton: HTMLButtonElement;

    public afterRender(): PromiseLike<void>
    {
        return super.afterRender().then(() =>
        {
            this.imageField.addEventListener('change', (e: Event) =>
            {
                if (this.imageField.files.length > 0)
                {
                    this.saveButton.disabled = false;
                    this.clearImageButton.disabled = false;
                    this.imageFilenameField.value = this.imageField.files[0].name;
                }
            });
        });
    }

    public onClearImageButtonClick(e: MouseEvent)
    {
        this.imageField.value = '';
        this.imageFilenameField.value = '';
        this.saveButton.disabled = true;
        this.clearImageButton.disabled = true;
    }

    public onCancelButtonClick(e: MouseEvent)
    {
        this.close(ModalResultType.CANCEL);
    }

    public onExtraInfoFocus(e: Event)
    {
        setTimeout(() =>
        {
            console.log(e);
            (e.target as Element).scrollIntoView();
        }, 500);
    }

    public onSaveButtonClick(E: MouseEvent)
    {
        this.submit();
    }

    public submit(data?: any): PromiseLike<void>
    {
        if (this.imageField.files.length == 0)
        {
            return Promise.resolve();
        }
        else
        {
            this.helpers.setButtonEnabled(this.saveButton, false);
            this.helpers.setButtonEnabled(this.cancelButton, false);
            this.helpers.setButtonEnabled(this.cameraButton, false);
            this.helpers.setButtonEnabled(this.clearImageButton, false);
            
            this.uploadSpeedNotification.style.display = 'block';
            new Promise((resolve, reject) =>
            {
                let reader = new FileReader();
                reader.addEventListener('load', (e) =>
                {
                    this.data.image = {
                        size: this.imageField.files[0].size,
                        data: reader.result
                    };

                    resolve();
                });
        
                reader.readAsDataURL(this.imageField.files[0]);
            }).then(() =>
            {
                this.app.synchronizer.createMessageAndPull({
                    action: ClientAction.ORDER_IMAGE_ADD,
                    data: {
                        order_id: this.data.id,
                        user_id: this.app.user.id,
                        filename: this.imageField.files[0].name,
                        data: this.data.image.data
                    }
                }).then(() => 
                {
                    this.app.toasts.show(this.pgettext('Order message', 'Order image successfully added!'));
                    this.trigger(ViewEvent.SUBMIT);
                    return this.unload();     

                }, () => 
                { 
                    this.helpers.setButtonEnabled(this.saveButton, true);
                });
                       
            });
        }
    }
}

export interface AddOrderImageModalViewData extends OrderFlipcardViewData
{
    image?: {
        size: number;
        data: string
    }
}